module.exports = "/assets/c7d87bafeb653c16b01005da0359fcd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/HU.png
// module id = 2577
// module chunks = 0